/*
    Studio Related Constants
*/

// These types must exactly match the shape type in appConstants.ts
// otherwise the shape will not be rendered
export const studioTypes = {
  Transcript: 'studio.Transcript',
  End: 'studio.End',
  Email: 'studio.Email',
  Start: 'studio.Start',
  Statement: 'studio.Statement',
  YesNo: 'studio.YesNo',
  List: 'studio.List',
  Text: 'studio.Text',
  Number: 'studio.Number',
  Dropdown: 'studio.Dropdown',
  Workflow: 'studio.Workflow',
  WorkflowParallel: 'studio.WorkflowParallel',
  WorkflowSequence: 'studio.WorkflowSequence',
  TableBuilder: 'studio.TableBuilder',
  FormBuilder: 'studio.FormBuilder',
  Report: 'studio.Report',
  DocReview: 'studio.DocReview',
  DocBuilder: 'studio.Report',
  Comp: 'studio.Comp',
  DecisionTable: 'studio.DecisionTable',
  Custom: 'studio.Custom',
  Merge: 'studio.Merge',
  Filter: 'studio.Filter',
  Loop: 'studio.Loop',
  LoopIn: 'studio.LoopIn',
  LoopOut: 'studio.LoopOut',
  JavaScript: 'studio.Custom',
  Section: 'studio.Section',
  Database: 'studio.Database',
  Status: 'studio.Status',
  Lawvu: 'studio.Lawvu',
  Salesforce: 'studio.Salesforce',
  Xakia: 'studio.Xakia',
  Docusign: 'studio.Docusign', // deprecated
  DocusignV2: 'studio.DocusignV2', // match the shape type in appConstants.ts
  Adobesign: 'studio.Adobesign',
  Ticket: 'studio.Ticket',
  // Link is a route type, not a page type
  Link: 'studio.Link',
} as const;

// field types for which their field_default_value should be searched for external refs
export const fieldTypesWithExternalRefs = ['PARA', 'LIST', 'FILE', 'DATE'];

export const blocksWithoutTooltips = [
  'TRANSCRIPT',
  'VIEW_REPORT',
  'END',
  'PARALLEL',
  'SEQUENCE',
];

export const fieldsWithQuestions = [
  'TXT',
  'NUM',
  'SEL',
  'RAD',
  'DATE',
  'SLDR',
  'CBX',
  'FILE',
  'USER',
  'DOC',
];

export const minimumAllowableZoom = 0.2;
export const maximumAllowableZoom = 2.0;

export const WORKFLOW_MESSAGE_EDITOR = 'workflow-message-editor';
